import type { PropsWithChildren, FunctionComponent, CSSProperties } from 'react'
import { DashText, type DashTextProps } from '../dash-text/DashText'
import { Flex } from '../flex/Flex'

const baseStyle: CSSProperties = { display: 'flex', alignItems: 'center' }

export const DashTableTextCell: FunctionComponent<PropsWithChildren<DashTextProps>> = ({
  size = 'small',
  overrideStyle = {},
  ...rest
}) => (
  <Flex fillWidth fillHeight align="center">
    <DashText
      size={size}
      elementType="div"
      overrideStyle={{ ...baseStyle, ...overrideStyle }}
      {...rest}
    />
  </Flex>
)
